import { formatDate } from "@angular/common";
import { RuleTableHandlers, TableConfig } from "../../../../../shared/ui/custom-table/model/table-config.model";
import { verifactuBadgeVariant, verifactuStatusTooltip } from "../../../../../shared/ui/status-pill/verifactu-badge.util";
import { Utils } from "../../../../../shared/utils";

export function createTicketTableConfig(
  handlers: RuleTableHandlers = {},
  options: { filterView?: string, defaultFilter?: any, isProjectEnable?: () => boolean } = {}
): TableConfig {
  const {
    onAction = () => { },
    actionMap = {},
    onRowClick = () => { },
    onRowDblClick = () => { },
    onRowExpand = () => { },
    summaryTemplate = () => { },
    selectable = false,
    rowConfig = {},
    headerActions,
    gridActions
  } = handlers;

  const handleAction = (row: any, action: TableRowAction) => {
    if (actionMap[action]) {
      actionMap[action](row);
    } else {
      onAction(row, action);
    }
  };

  const isProjectEnable = options.isProjectEnable || (() => false);

  return {
    columns: [
      { key: 'ticketNumber', label: 'Ticket', sortable: true, sortKey: 'TicketNumber', onCellClick: (row) => handleAction(row, TableRowAction.Pdf) },
      { key: 'receiverName', label: 'Cliente', sortable: true, sortKey: 'ReceiverName' },
      { key: 'date', label: 'Fecha', sortable: true, sortKey: 'Date', formatFn: (val) => val ? formatDate(val, 'dd/MM/yyyy', 'es-ES') : '' },
      { key: 'total', label: 'Total', sortable: true, sortKey: 'Total', onCellClick: (row) => handleAction(row, TableRowAction.Charge), formatFn: (val) => val != null ? Utils.FormatMoney(val) + ' €' : '' },
      { key: 'fullPaid', label: 'Cobrado', sortable: true, sortKey: 'FullPaid', formatFn: (val) => val != null ? Utils.FormatMoney(val) + ' €' : '' },
      {
        key: 'collectionDate', label: 'Fecha de cobro', sortable: true, sortKey: 'CollectionDate',
        badge: {
          variantFn: (value: string) => value ? 'success' : 'warning',
          labelFn: (value: string) => value ? formatDate(value, 'dd/MM/yyyy', 'es-ES') : 'Pendiente',
        },
      },
      {
        key: 'verifactuStatusName', label: 'Verifactu', sortable: true, sortKey: 'VerifactuStatus',
        badge: {
          variantFn: (value: string) => verifactuBadgeVariant(value),
          labelFn: (value: string) => value || '—',
        },
        tooltipFn: (row: any) => verifactuStatusTooltip(row.verifactuStatusName),
      },
    ],

    actions: [
      { label: 'PDF', icon: 'dvr', callback: (row) => handleAction(row, TableRowAction.Pdf) },
      { label: 'Ticket regalo', icon: 'description', callback: (row) => handleAction(row, TableRowAction.TicketGift) },
      { label: 'Enviar PDF', icon: 'send', callback: (row) => handleAction(row, TableRowAction.PdfMail) },
      {
        label: (row) => row.collectionDate ? `Cobrada (${formatDate(row.collectionDate, 'dd/MM/yyyy', 'es-ES')})` : 'Asignar cobro',
        icon: 'payment',
        visible: (row) => !!row.collectionDate || !row.rectifying,
        callback: (row) => handleAction(row, TableRowAction.Charge),
      },
      { label: 'Proyecto', icon: 'work', visible: () => isProjectEnable(), callback: (row) => handleAction(row, TableRowAction.Project) },
      { label: 'Rectificar', icon: 'history', visible: (row) => !row.rectifying, callback: (row) => handleAction(row, TableRowAction.Rectify) },
      { label: 'Detalle Verifactu', icon: 'verified_user', callback: (row) => handleAction(row, TableRowAction.Verifactu) },
    ],
    headerActions: headerActions,
    gridActions: gridActions,
    filterView: options.filterView || 'viewSummaryTicketFilters',
    defaultFilter: options.defaultFilter || {},
    rowConfig: {
      ...rowConfig,
      clickable: true,
      onClick: onRowClick,
      onDoubleClick: onRowDblClick,
      onExpand: onRowExpand,
    },
    selectable: selectable,
    pagination: false,
    summaryTemplate: summaryTemplate
  };
}

export enum TableRowAction {
  Rectify = 'Rectificar',
  Pdf = 'PDF',
  TicketGift = 'Ticket Regalo',
  Charge = 'Charge',
  PdfMail = 'PdfMail',
  Verifactu = 'Verifactu',
  Project = 'Project',
}
